import { RoleManagementImpl } from "../data/RoleManagementImpl";
import { IRoleManagementRepository } from "../domain/repositories/IRoleManagementRepository";
import { RoleManagementUseCase } from "../domain/useCases/RoleManagementUseCase";
import { RoleManagementViewModel } from "../presentation/viewModel/RoleManagementViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class RoleManagementInjection extends InjectionModule {
  private static readonly roleManagementRepositoryToken = Symbol(
    "IRoleManagementRepository",
  );
  private static readonly roleManagementUseCaseToken = Symbol(
    "RoleManagementUseCase",
  );
  private static readonly roleManagementViewModelToken = Symbol(
    "RoleManagementViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.roleManagementRepositoryToken,
      useClass: RoleManagementImpl,
    },
    {
      scope: "otherRepo",
      token: this.roleManagementUseCaseToken,
      useClass: RoleManagementUseCase,
    },
    {
      scope: "viewModel",
      token: this.roleManagementViewModelToken,
      useClass: RoleManagementViewModel,
    },
  ];

  static getRepo(): IRoleManagementRepository {
    return this.resolve(this.roleManagementRepositoryToken);
  }

  static getUseCase(): RoleManagementUseCase {
    return this.resolve(this.roleManagementUseCaseToken);
  }
}
